// Description: 版本信息
export const VERSION_CODE = import.meta.env.VITE_APP_VERSION
/**
 * 设置版本信息
 * @param {*} version
 */
export const setVersion = (version) => {
  localStorage.setItem('VITE_APP_VERSION', Number(version) || -1)
}

/**
 * 获取版本信息
 * @returns
 */
export const getVersion = () => {
  return localStorage.getItem('VITE_APP_VERSION') || -1
}

/**
 * 校验版本信息
 * @returns
 */
export const checkVersion = (targetVersion) => {
  const version = getVersion()
  // console.log('版本信息', targetVersion, version)
  return version >= targetVersion
}
